
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.616 5.797h0l-.003.003c-.25.24-.364.591-.305.93h0v.004l.444 2.456a.052.052 0 01-.002.028.033.033 0 01-.013.015l-.007.005-.006.004a.042.042 0 01-.023.009c-.008 0-.02-.001-.033-.008l-.002-.001-2.214-1.155h0l-.01-.005a1.065 1.065 0 00-.472-.117h-.16l-.025.002a.884.884 0 00-.297.09l-.005.002-.008.004-.007.004-2.21 1.157a.087.087 0 01-.039.009c-.033-.01-.044-.038-.041-.06l.444-2.454h0l.001-.007a1.06 1.06 0 00-.298-.925h0l-.007-.006L.517 4.035A.06.06 0 01.5 4.008a.027.027 0 010-.016h.001l.003-.009c.005-.016.02-.033.048-.039l2.47-.358c.355-.041.664-.258.824-.577h0l.002-.005L4.94.772l.01-.009.017-.013h.065a.06.06 0 01.034.027l1.106 2.229c.155.318.453.523.783.577h0l.01.002 2.484.36h.001a.067.067 0 01.052.04.043.043 0 01-.013.04h0l-.002.002-1.87 1.77z","stroke":"#1C2F45"}})])
          )
        }
      }
    